export const about = {
  hero: {
    title: 'À propos de BridgeCore empowermennt initiative',
    subtitle: 'Depuis plus de 8 ans, BridgeCore empowermennt initiative est un phare de lumière pour les réfugiés et les communautés vulnérables en République démocratique du Congo. Nous croyons que chaque personne mérite la dignité, la sécurité et l\'opportunité de reconstruire sa vie avec espoir et détermination.',
    stats: {
      yearsOfService: 'Années de service',
      livesImpacted: 'Vies touchées',
      activeProjects: 'Projets actifs',
      teamMembers: 'Membres de l\'équipe',
    },
  },
  mission: {
    badge: 'Notre mission',
    text: 'Fournir une aide d\'urgence, des soins de santé, une éducation et des solutions durables qui restaurent la dignité et l\'espoir aux réfugiés et aux communautés vulnérables en RDC.',
    teamMembers: 'Membres dévoués de l\'équipe',
    volunteers: 'Bénévoles actifs',
    visionTitle: 'Notre vision',
    visionText: 'Un avenir où chaque réfugié et personne déplacée en RDC a accès aux services essentiels, à l\'éducation et aux opportunités de reconstruire sa vie avec dignité et espoir.',
    valuesTitle: 'Nos valeurs',
    values: {
      compassion: 'Compassion et dignité',
      transparency: 'Transparence et responsabilité',
      empowerment: 'Autonomisation communautaire',
    },
  },
  team: {
    title: 'Rencontrez notre équipe de direction',
    subtitle: 'Des professionnels dévoués engagés à avoir un impact durable dans la vie des réfugiés et des communautés vulnérables.',
  },
  partners: {
    title: 'Nos partenaires',
    subtitle: 'Travailler ensemble avec des organisations internationales et des communautés locales pour maximiser notre impact et notre portée.',
    achievementsTitle: 'Réalisations clés',
    achievementsSubtitle: 'Des jalons qui témoignent de notre engagement et de notre impact',
    awards: {
      humanitarian: {
        title: 'Prix humanitaire 2023',
        description: 'Reconnu pour un service exceptionnel aux communautés de réfugiés',
      },
      certified: {
        title: 'ONG certifiée',
        description: 'Entièrement accrédité par les normes humanitaires internationales',
      },
      rating: {
        title: 'Note 5 étoiles',
        description: 'Meilleure note pour la transparence et l\'efficacité de l\'impact',
      },
    },
  },
  volunteer: {
    title: 'Devenez bénévole',
    subtitle: 'Rejoignez notre équipe et ayez un impact direct dans la vie des réfugiés et des communautés vulnérables.',
  },
};
